export default {
	"loading.default": "Daten werden geladen",
} as const;
